module.exports = __webpack_public_path__ + "img/1440.61301755.jpg";